import { ConfigModel } from '@ibe/services';

class MegConfigModel extends ConfigModel {
  hideSpecialRequests?: boolean;

  disablePackageNavigation?: boolean;

  hideMoveTicketOnHotelList?: boolean;

  disableBookingOverviewAddressChange?: boolean;

  paymentStyleUrl?: string;

  paymentCheckoutIntegration?: boolean;

  hotelListResultsQuantity?: number;

  hideOccupancyInRoomsItem?: boolean;

  cachePackageComponentsRequests?: boolean;

  hidePaymentInformation?: boolean;

  showTravelPlan?: boolean;

  multipleTimeSlots?: boolean;

  showWalletLinks?: boolean;

  showCurrencySelection?: boolean;

  conference?: {
    entryCode?: string;
    paymentType?: string;
    taxNumberMaxLength?: number;
  };

  enableOptionalRelatedServices?: boolean;

  whitelabelThemeNumber?: number;

  payConnectWaitTime?: number;

  payConnectWaitSelector?: string;

  translations?: {
    useEmptyString?: boolean;
  };

  bookingPaymentCountdownTime?: number;

  dealFinderPriceRoundingMode?:
    | 'DEFAULT_MODE'
    | 'ROUND_HALF_DOWN_MODE'
    | 'ROUND_DOWN_MODE'
    | 'ROUND_UP_MODE';

  dealfinderCacheTimezone?: string;

  dealFinderDefaultTolerancePlus?: number;

  dealFinderDefaultToleranceMinus?: number;

  enablePerNightPrice?: boolean;

  clearpayConfig?: {
    enabled: boolean;
    dataMpid: string;
    dataPlacementId: string;
    allowedLanguages: string[];
  };

  monthPickerMaxMonths?: number;

  enableNewManageMyBooking?: boolean;
}

export default MegConfigModel;
